import { SegmentTypeEnum } from '../../../../shared/graphql-types';
import { Airport } from './airport';
import { Order } from './order';

export class ItinerarySegment {
  type: SegmentTypeEnum;
  eft?: number;
  departureTime: Date;
  departureAirport: Airport;
  arrivalTime: Date;
  arrivalAirport: Airport;
  availableFlightId?: string;
  flight?: Order;
}
